export default __webpack_public_path__ + "images/N4.7fd6107.png";